<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="col-md-10 offset-md-1" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHTML]="'tkey;admin.microsoft.license_management.about' | escapeHtml"></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    @if (!isLoading) {
      <div>
        <ziro-microsoft-license-management-form
          [entity]="formEntity"
          [usageLocationOptions]="usageLocationOptions"
          [licensesOptions]="licensesOptions"
          [ms365Licenses]="ms365Licenses"
          [tenantId]="tenantInfo?.tenantId"
        ></ziro-microsoft-license-management-form>
      </div>
    }
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
